import { render, staticRenderFns } from "./ReturnBtn.vue?vue&type=template&id=e148d34e&scoped=true&"
import script from "./ReturnBtn.vue?vue&type=script&lang=js&"
export * from "./ReturnBtn.vue?vue&type=script&lang=js&"
import style0 from "./ReturnBtn.vue?vue&type=style&index=0&id=e148d34e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e148d34e",
  null
  
)

export default component.exports